import inView from './in-view.js';
module.exports = inView;
